"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _dsIcons = require("@olxbr/ds-icons");
var _actions = require("../../../actions");
var _selectors = require("../../../selectors");
var _dateutil = require("../../../helpers/dateutil");
var _style = require("./style");
var _MiniProfileRemoteComponent = _interopRequireDefault(require("../MiniProfileRemoteComponent"));
var _platform = require("../../../helpers/platform");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var UserInfo = /*#__PURE__*/function (_PureComponent) {
  function UserInfo() {
    var _this;
    _classCallCheck(this, UserInfo);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UserInfo, [].concat(args));
    _defineProperty(_this, "_renderStatus", function () {
      var _this$props = _this.props,
        online = _this$props.online,
        lastTimeOnline = _this$props.lastTimeOnline,
        currentChat = _this$props.currentChat,
        isAdview = _this$props.isAdview;
      if (online) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Divisor, {
            isAdview: isAdview
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.UserStatusWrapper, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.OnlineWrapper, {
              currentChat: currentChat,
              isAdview: isAdview,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Circle, {
                isAdview: isAdview
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.UserStatus, {
              title: "online",
              isAdview: isAdview,
              children: "online"
            })]
          })]
        });
      } else if (lastTimeOnline) {
        var lastAccess = "\xDAltimo acesso ".concat(lastTimeOnline);
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Divisor, {
            isAdview: isAdview
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.UserStatus, {
            offline: "true",
            title: lastAccess,
            isAdview: isAdview,
            children: lastAccess
          })]
        });
      }
      return null;
    });
    return _this;
  }
  _inherits(UserInfo, _PureComponent);
  return _createClass(UserInfo, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        id = _this$props2.id,
        name = _this$props2.name,
        facematch = _this$props2.facematch,
        redirectToUserProfileAction = _this$props2.redirectToUserProfileAction,
        isAdview = _this$props2.isAdview;
      var facematchParsedObject = JSON.parse(facematch);
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.VerifiedIconWrapper, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.UserName, {
            title: name,
            onClick: redirectToUserProfileAction,
            children: name
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.IconWrapper, {
            children: id && (facematchParsedObject === null || facematchParsedObject === void 0 ? void 0 : facematchParsedObject.profileVerified) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.Verified, {
              color: "var(--color-feedback-success-100)",
              size: "13"
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.StatusWrapper, {
          children: [!isAdview && !_platform.isMsite && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MiniProfileRemoteComponent["default"], {
            isAdview: isAdview,
            onPressRedirectToUserProfile: redirectToUserProfileAction,
            fallback: function fallback() {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.SeeProfile, {
                onClick: redirectToUserProfileAction,
                isAdview: isAdview,
                children: "Ver perfil"
              });
            }
          }), this._renderStatus()]
        })]
      });
    }
  }]);
}(_react.PureComponent);
_defineProperty(UserInfo, "propTypes", {
  online: _propTypes.bool,
  name: _propTypes.string,
  lastTimeOnline: _propTypes.string,
  id: _propTypes.string,
  facematch: _propTypes.bool,
  redirectToUserProfileAction: _propTypes.func.isRequired,
  isAdview: _propTypes.bool,
  currentChat: _propTypes.string
});
_defineProperty(UserInfo, "defaultProps", {
  online: false,
  name: '',
  lastTimeOnline: '',
  id: '',
  facematch: false,
  isAdview: false,
  currentChat: ''
});
var mapStateToProps = function mapStateToProps(state) {
  var _getCurrentPartner = (0, _selectors.getCurrentPartner)(state),
    id = _getCurrentPartner.id,
    facematch = _getCurrentPartner.facematch,
    online = _getCurrentPartner.online,
    name = _getCurrentPartner.name,
    lastTimeOnline = _getCurrentPartner.lastTimeOnline;
  return {
    id: id,
    facematch: facematch,
    online: online,
    name: name,
    lastTimeOnline: lastTimeOnline ? (0, _dateutil.formatLastTimeOnline)(lastTimeOnline) : ''
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _actions.bindActionCreators)({
    redirectToUserProfileAction: _actions.redirectToUserProfile
  }, dispatch);
};
var _default = exports["default"] = (0, _actions.connect)(mapStateToProps, mapDispatchToProps)(UserInfo);